import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import { updateCallRouting } from 'flow/actions/call-routing-actions';
import Button from 'flow/components/ui-components/Button';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import { BlocklistKey } from 'flow/types/EntityKeys';
import { BlockistParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { generatePath } from 'flow/utils/router-utils';
import Page from '../Page';
import SettingRow from '../SettingRow';

const EditCallRoutingException = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, blocklistKey, type } = useParams<BlockistParams>();
    const callRouting = useAppSelector((state) =>
        state.callRoutings.getIn([type, blocklistKey]),
    );

    if (!callRouting) {
        return <Loading />;
    }

    const updateCallRoutingActionAndGoBack = (selected: BlocklistKey) => {
        const updatedCallRoutingExceptions = callRouting
            .get('blocklistExceptions')
            .filter((exception) => exception.get('key') !== selected);
        let updatedCallRoutingDTO: any;
        updatedCallRoutingDTO = callRouting.update(
            'blocklistExceptions',
            () => updatedCallRoutingExceptions,
        );

        dispatch(updateCallRouting(updatedCallRoutingDTO));

        history.push(
            generatePath(
                routes[
                    'settings.softphone.advanced.callrouting.type.blocklistKey.exception'
                ],
                { extensionKey, type, blocklistKey },
            ),
        );
    };

    return (
        <Page
            header={'settings.callrouting.exceptions'}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'settings.softphone.advanced.callrouting.type.blocklistKey'
                        ],
                        { extensionKey, type, blocklistKey },
                    ),
                )
            }
        >
            <div className="mb-2 flex">
                <Button
                    color="primary"
                    onClick={() => {
                        history.push(
                            generatePath(
                                routes[
                                    'settings.softphone.advanced.callrouting.type.blocklistKey.exception.add'
                                ],
                                {
                                    extensionKey,
                                    type,
                                    blocklistKey,
                                },
                            ),
                        );
                    }}
                    iconKey="add"
                    className="py-1"
                >
                    {i18next.t('settings.callrouting.exceptions.add')}
                </Button>
            </div>

            {callRouting.get('blocklistExceptions')?.map((exception) => (
                <SettingRow
                    key={exception.get('key')}
                    cta={
                        <Button
                            iconKey="delete"
                            onClick={() =>
                                updateCallRoutingActionAndGoBack(
                                    exception.get('key'),
                                )
                            }
                        />
                    }
                >
                    {exception.get('matcher')}
                </SettingRow>
            ))}
        </Page>
    );
};

export default EditCallRoutingException;
